import { render, staticRenderFns } from "./Form.Docs.vue?vue&type=template&id=0328ad63"
import script from "./Form.Docs.vue?vue&type=script&lang=js"
export * from "./Form.Docs.vue?vue&type=script&lang=js"
import style0 from "./Form.Docs.vue?vue&type=style&index=0&id=0328ad63&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports